/**
 * Toggle opening/closing search bar
 */
class SearchToggle {
    constructor() {}

    close() {
        if(this.searchActivator != null) {
            this.searchActivator.classList.remove('open')
            this.searchActivator.classList.add('close')
        }

        if(this.searchWrap != null) {
            this.searchWrap.classList.remove('open')
            this.searchWrap.classList.add('close')
        }
    }

    open() {
        if(this.searchActivator != null) {
            this.searchActivator.classList.remove('close')
            this.searchActivator.classList.add('open')
        }

        if(this.searchWrap != null) {
            this.searchWrap.classList.remove('close')
            this.searchWrap.classList.add('open')
        }

        if(this.searchInput != null) {
            this.searchInput.focus()
        }
    }

    init() {
        this.searchActivator = document.querySelector('.search-act')
		this.searchWrap = document.querySelector('.searchWrapDesktop')
		

        if(this.searchActivator && this.searchWrap) {
            this.searchInput = this.searchWrap.querySelector('input.searchInput')
			this.searchActivator.addEventListener('click', (e) => {
				if(this.searchActivator.classList.contains('open')) {
                    this.close()
				}
				else {
                    this.open()
				}
			})
		}
    }
}

export default new SearchToggle() // singleton instance
